<template>
  <div class="vip-page">
    <van-nav-bar title="开通VIP会员" @click-left="$router.back()">
      <template #left>
        <van-icon name="arrow-left" size="22" />
      </template>
    </van-nav-bar>

    <div class="page-content">
      <!-- 余额支付成功页面（最高优先级） -->
      <div v-if="paySuccess" class="success-wrap">
        <div class="success-icon">
          <van-icon name="success" size="60" color="#36d399"/>
        </div>
        <h2 class="success-title">VIP开通成功！</h2>
        <div class="info-card">
          <div class="info-row">
            <span class="label">购买套餐</span>
            <span class="val">{{ successData.plan_name }}</span>
          </div>
          <div class="info-row">
            <span class="label">有效时长</span>
            <span class="val">{{ successData.day_num }} 天</span>
          </div>
          <div class="info-row">
            <span class="label">会员到期时间</span>
            <span class="val">{{ successData.end_time }}</span>
          </div>
        </div>
        <van-button class="back-btn" size="large" @click="$router.push('/self')">
          返回个人中心
        </van-button>
      </div>

      <!-- 用户已有有效VIP -->
      <div v-else-if="userVipInfo.is_vip" class="owned-vip-wrap">
        <div class="success-icon">
          <van-icon name="vip" size="60" color="#ffd479"/>
        </div>
        <h2 class="success-title">您已是VIP会员</h2>
        <div class="info-card">
          <div class="info-row">
            <span class="label">会员到期时间</span>
            <span class="val">{{ userVipInfo.vip_expire_date }}</span>
          </div>
        </div>
        <div class="tip-desc">
          您可以继续选购套餐续费，延长会员有效期
        </div>
      </div>

      <!-- 未开通VIP，展示套餐列表 -->
      <div v-else>
        <div class="header-tip">
          <h2>✨解锁完整影片观看权限✨</h2>
          <p>开通VIP会员，告别试看限制，畅享全部高清视频</p>
        </div>

        <div class="plan-list">
          <div
            class="plan-item"
            v-for="item in planList"
            :key="item.id"
            :class="{active: selectId === item.id}"
            @click="selectPlan(item)"
          >
            <!-- 推荐标签 -->
            <div v-if="item.plan_type === 5" class="hot-tag">🔥超值推荐</div>
            <div class="plan-left">
              <div class="plan-name">{{ item.plan_name }}</div>
              <div class="plan-day">有效期 {{ item.day_num }} 天</div>
              <div class="tip-text" v-if="item.plan_type === 5">日均低至0.27元</div>
            </div>
            <div class="plan-price">
              <span class="rmb">¥</span>
              <span class="num">{{ item.price }}</span>
            </div>
            <!-- 选中圆圈标识 -->
            <div class="check-icon" v-if="selectId === item.id">
              <van-icon name="success" size="16" color="#fff"/>
            </div>
          </div>
        </div>

        <div class="btn-group">
          <van-button
            class="submit-btn pay-btn"
            size="large"
            :disabled="!selectId"
            @click="contactService"
          >
            {{ selectId ? '立即支付开通' : '请选择会员套餐' }}
          </van-button>
          <van-button
            class="submit-btn balance-btn"
            size="large"
            type="default"
            :disabled="!selectId"
            @click="balancePayOpen"
          >
            余额支付开通
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vipBuy",
  data() {
    return {
      planList: [],
      selectId: null,
      selectedPlan: null,
      paySuccess: false,
      successData: {
        plan_name: "",
        day_num: "",
        end_time: ""
      },
      // 用户VIP状态数据
      userVipInfo: {
        is_vip: false,
        vip_end_time: 0,
        vip_expire_date: null
      }
    };
  },
  mounted() {
    this.getVipPlan();
    this.getUserVipStatus();
  },
  methods: {
    getVipPlan() {
      let that = this;
      that.$apiFun.get("/api/getVipPlan").then((res) => {
        console.log("套餐返回数据：", res);
        if (res.code === 200) {
          that.planList = res.data;
        }
      });
    },
    // 新增：获取用户VIP状态接口
    getUserVipStatus() {
      let that = this;
      that.$apiFun.post("/api/getVipUserInfo").then(res => {
        console.log("vip状态：", res);
        if (res.code === 200) {
          that.userVipInfo = res.data;
        }
      });
    },
    selectPlan(item) {
      this.selectId = item.id;
      this.selectedPlan = item;
    },
    // 立即支付开通 - 提示联系客服
    contactService() {
      this.$toast("请联系客服开通");
    },
    // 余额支付开通
    balancePayOpen() {
      if (!this.selectedPlan) return;
      this.$toast.loading("正在发起余额支付...");
      this.$apiFun.post('/api/vipBalancePay', {plan_id: this.selectId}).then(res => {
        this.$toast.clear();
        if(res.code === 200){
          // 格式化时间戳为日期
          const endTimestamp = res.data.vip_end_time;
          const dateObj = new Date(endTimestamp * 1000);
          const formatTime = `${dateObj.getFullYear()}-${String(dateObj.getMonth()+1).padStart(2,'0')}-${String(dateObj.getDate()).padStart(2,'0')} ${String(dateObj.getHours()).padStart(2,'0')}:${String(dateObj.getMinutes()).padStart(2,'0')}`;

          this.successData = {
            plan_name: this.selectedPlan.plan_name,
            day_num: this.selectedPlan.day_num,
            end_time: formatTime
          };
          this.paySuccess = true;
        }else{
          this.$toast(res.msg);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.vip-page {
  background: linear-gradient(180deg, #141426 0%, #1c1c38 100%);
  min-height: 100vh;
  overflow-x: hidden;
}
.page-content {
  padding: 20px 16px;
  box-sizing: border-box;
}
.header-tip {
  text-align: center;
  padding: 16px 10px 28px;
  h2 {
    font-size: 24px;
    color: #ffd479;
    margin: 0 0 8px;
    letter-spacing: 1px;
  }
  p {
    color: #b8b8d8;
    font-size: 14px;
  }
}

.plan-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 36px;
  box-sizing: border-box;

  .plan-item {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 18px;
    padding: 24px 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.12);
    transition: all 0.3s ease;
    cursor: pointer;

    &:active {
      transform: scale(0.98);
    }

    &.active {
      border-color: #ff9b40;
      background: rgba(255, 155, 64, 0.12);
      box-shadow: 0 0 22px rgba(255, 155, 64, 0.25);
    }

    .hot-tag {
      position: absolute;
      right: 22px;
      top: -10px;
      background: linear-gradient(90deg,#ff6b57,#ff9b40);
      color: #fff;
      font-size: 11px;
      padding: 3px 10px;
      border-radius: 12px;
    }

    .plan-left {
      text-align: left;
      .plan-name {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
      }
      .plan-day {
        font-size: 13px;
        color: #b8b8d8;
        margin-top: 6px;
      }
      .tip-text{
        font-size:12px;
        color:#ffd479;
        margin-top:4px;
      }
    }

    .plan-price {
      .rmb {
        font-size: 16px;
        color: #ff9b40;
      }
      .num {
        font-size: 30px;
        color: #ff9b40;
        font-weight: bold;
      }
    }

    .check-icon{
      position:absolute;
      left:14px;
      top:14px;
      width:20px;
      height:20px;
      background:#ff9b40;
      border-radius:50%;
      display:flex;
      align-items:center;
      justify-content:center;
    }
  }
}

.btn-group{
  display:flex;
  gap:14px;
}
.submit-btn {
  flex:1;
  height: 50px;
  font-size: 16px;
  font-weight:500;
  border-radius: 12px;
}
.pay-btn{
  background: linear-gradient(90deg, #ff6b57, #ff9b40) !important;
  border: none;
}
.balance-btn{
  border:1px solid #ff9b40;
  color:#ff9b40;
  background:transparent !important;
}

// 开通成功页面样式
.success-wrap{
  margin-top:60px;
  text-align:center;
  .success-icon{
    margin-bottom:16px;
  }
  .success-title{
    font-size:24px;
    color:#fff;
    margin-bottom:30px;
  }
  .info-card{
    background:rgba(255,255,255,0.06);
    border-radius:16px;
    padding:24px;
    margin-bottom:40px;
    .info-row{
      display:flex;
      justify-content:space-between;
      padding:12px 0;
      border-bottom:1px solid rgba(255,255,255,0.1);
      &:last-child{
        border:none;
      }
      .label{
        color:#b8b8d8;
      }
      .val{
        color:#ffd479;
      }
    }
  }
  .back-btn{
    width:100%;
    height:50px;
    background: linear-gradient(90deg, #ff6b57, #ff9b40) !important;
    border:none;
    border-radius:12px;
    font-size:16px;
  }
}

// 已有VIP会员页面
.owned-vip-wrap{
  margin-top:60px;
  text-align:center;
  .success-icon{
    margin-bottom:16px;
  }
  .success-title{
    font-size:24px;
    color:#fff;
    margin-bottom:30px;
  }
  .info-card{
    background:rgba(255,255,255,0.06);
    border-radius:16px;
    padding:24px;
    margin-bottom:20px;
    .info-row{
      display:flex;
      justify-content:space-between;
      padding:12px 0;
      .label{
        color:#b8b8d8;
      }
      .val{
        color:#ffd479;
      }
    }
  }
  .tip-desc{
    color:#b8b8d8;
    font-size:13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/vipBuy.vue